"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasScrollLock = void 0;

// State functions
// Mixins for common state-specific styles like scroll-locking, prefixed with `is` or `has`.
// --------------------------------------------------------
const hasScrollLock = () => ({
  position: "absolute",
  width: "100%",
  overflow: "hidden"
});

exports.hasScrollLock = hasScrollLock;